const billReports = {
  description:
    'Bietet einen Überblick über Fahrt- und Fahrgastdetails, einschließlich Fahrtlogistik, Status und Schlüsselkennzahlen für die Abrechnung und Prüfung von Transportdiensten.',
  actions: {
    export: 'Exportieren',
  },

  table: {
    headers: {
      tripId: 'Fahrt-ID',
      jobId: 'Buchungs-ID',
      waitAndReturn: 'Warten und zurückkehren',
      externalId: 'Externe ID',
      jobStatus: 'Buchungsstatus',
      actualPickupTime: 'Tatsächliche Abholzeit',
      actualDropTime: 'Tatsächliche Ausstiegszeit',
      plannedPickupTime: 'Geplante Abholzeit',
      plannedDropTime: 'Geplante Ausstiegszeit',
      canceledBy: 'Abgebrochen von',
      assignedBy: 'Zugewiesen von',
      routeId: 'Routen-ID',
      tripStatus: 'Fahrtstatus',
      isShared: 'Geteilt',
      supplier: 'Anbieter',
      areas: 'Zonen',
      from: 'Von',
      to: 'Bis',
      date: 'Datum',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      profile: 'Profil',
      passenger: 'Fahrgast',
      email: 'E-Mail',
      phone: 'Telefon',
      attributes: 'Attribut',
      cost: 'Kosten',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'Neu',
          onhold: 'In der Warteschleife',
          cancelled: 'Storniert',
          routing: 'Routenplanung',
          routed: 'Geroutet',
          picked: 'Ausgewählt',
          dropped: 'Abgesetzt',
          noshow: 'No-Show',
        },
      },
    },

    filters: {
      assigned: {
        automated: 'Automatisiert zugewiesen',
        manually: 'Manuell zugewiesen',
        manuallyIntegration: 'Manuell zugewiesen (Integration)',
        all: 'Automatisiert und manuell zugewiesen',
      },
      shared: {
        onlyWithout: 'Nicht geteilt',
        onlyWith: 'Geteilt',
        all: 'Geteilt & Nicht geteilt',
      },

      tripStatus: 'Fahrtstatus',
      jobStatus: 'Buchungsstatus',
      vehicles: 'Fahrzeuge',
      drivers: 'Fahrer',
      suppliers: 'Lieferanten',
      profiles: 'Profil',
      areas: 'Zonen',
      locations: 'Standardstandorte',
      airportLocations: 'Flughafenstandorte',
      attributes: 'Attribut',
    },
  },
  tableSummary: {
    title: 'Shuttle-Berichte',
    headers: {
      trips: 'Fahrten',
      jobs: 'Buchungen',
      vehicles: 'Fahrzeuge',
      shared: 'Geteilt',
      autoAssigned: 'Automatisch zugewiesen',
      waitAndReturn: 'Warten und zurückkehren',
    },
  },
};

export default billReports;
